import { SellerFilter } from '@/components/SellerFilter/SellerFilter';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import {
  Box,
  Checkbox,
  IconButton,
  InputAdornment,
  ListItemText,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './CustomDateRangePicker.css';
import { useFiltersViewController } from './FiltersViewController';

export function Filters(props: { onlyPendingOrders?: boolean }) {
  const { uiState, actions } = useFiltersViewController(
    props.onlyPendingOrders ?? false
  );

  return (
    <Box
      component="form"
      autoComplete="off"
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        height: '100%',
        overflowX: 'auto',
        overflowY: 'hidden',
        padding: { xs: '8px', md: 'unset' },
      }}
    >
      <TextField
        placeholder="Buscar por ID Pedido"
        sx={{
          mr: '8px',
          flexShrink: 0,
          minWidth: { xs: '80px', sm: 'auto' },
        }}
        onChange={(e) => {
          actions.onOrderIdChanged(e.target.value);
        }}
        value={uiState.orderId}
        InputProps={{
          endAdornment: uiState.showClearOrderId ? (
            <IconButton onClick={actions.cleanOrderId}>
              <ClearOutlinedIcon />
            </IconButton>
          ) : null,
        }}
      />

      <Stack direction="row" spacing="8px">
        <DatePicker
          selectsRange
          startDate={uiState.startDate}
          endDate={uiState.endDate}
          onChange={(update) => actions.updateDateRange(update)}
          calendarStartDay={1}
          customInput={
            <TextField
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <CalendarTodayIcon />
                  </InputAdornment>
                ),
                endAdornment: uiState.showClearDateRange ? (
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      actions.cleanDateRange();
                    }}
                  >
                    <ClearOutlinedIcon />
                  </IconButton>
                ) : null,
                inputProps: {
                  placeholder: 'Fecha',
                },
              }}
            />
          }
          dateFormat={'dd MMM yy'}
        />

        <SellerFilter
          onFilterChanged={actions.onSellerFilterChanged}
          sx={{
            width: '200px',
          }}
          initialSelected={uiState.selectedSellersInitiallySelected}
        />

        {uiState.showStatusFilter && (
          <Select
            displayEmpty
            value={uiState.selectedStatusId}
            onChange={(e) => actions.onStatusFilterChanged(e.target.value)}
            renderValue={() =>
              uiState.statusSelectedValue ? (
                uiState.statusSelectedValue
              ) : (
                <Typography sx={{ fontSize: '12px', pt: '4px' }}>
                  Estatus
                </Typography>
              )
            }
            endAdornment={
              uiState.showClearStatusFilter ? (
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    actions.onStatusFilterClearClicked();
                  }}
                >
                  <ClearOutlinedIcon />
                </IconButton>
              ) : null
            }
          >
            {uiState.statusOptions.map((statusOption) => (
              <MenuItem
                key={statusOption.statusId}
                value={statusOption.statusId}
              >
                {statusOption.statusName}
              </MenuItem>
            ))}
          </Select>
        )}

        {uiState.showRemissionStatusFilter && (
          <Select
            displayEmpty
            value={uiState.remissionStatusId}
            onChange={(e) => actions.onRemissionFilterChanged(e.target.value)}
            renderValue={() =>
              uiState.remissionStatusSelectedValue ? (
                uiState.remissionStatusSelectedValue
              ) : (
                <Typography sx={{ fontSize: '12px', pt: '4px' }}>
                  Remision
                </Typography>
              )
            }
            endAdornment={
              uiState.showClearRemissionStatusFilter ? (
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    actions.onRemissionFilterClearClicked();
                  }}
                >
                  <ClearOutlinedIcon />
                </IconButton>
              ) : null
            }
          >
            {uiState.remisionStatusOptions.map((remisionStatusOption) => (
              <MenuItem
                key={remisionStatusOption.statusId}
                value={remisionStatusOption.statusId}
              >
                {remisionStatusOption.statusName}
              </MenuItem>
            ))}
          </Select>
        )}

        <Select
          multiple
          value={uiState.selectedKamIds}
          onChange={(e) => actions.onKamFilterChanged(e.target.value)}
          displayEmpty
          renderValue={() =>
            uiState.kamsSelectedValue ? (
              uiState.kamsSelectedValue
            ) : (
              <Typography sx={{ fontSize: '12px', pt: '4px' }}>KAM</Typography>
            )
          }
          endAdornment={
            uiState.showClearKamFilter ? (
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  actions.onKamFilterClearClicked();
                }}
              >
                <ClearOutlinedIcon />
              </IconButton>
            ) : null
          }
        >
          {uiState.kamFilterOptions.map((kamOption) => (
            <MenuItem key={kamOption.id} value={kamOption.id}>
              <Checkbox
                checked={uiState.selectedKamIds.includes(kamOption.id)}
              />
              <ListItemText>{kamOption.name}</ListItemText>
            </MenuItem>
          ))}
        </Select>
      </Stack>
    </Box>
  );
}
